export default __webpack_public_path__ + "static/media/Vector(2).8aa83f4d.svg";